import React from 'react'
import PropTypes from 'prop-types'
import DownloadLinkSets from './DownloadLinkSets'

const DownloadLinksContainer = props => {
  return (
    <div>
      <DownloadLinkSets
        coursenum={props.coursenum}
        timeframe={props.timeframe}
      />
    </div>
  )
}

DownloadLinksContainer.propTypes = {
  coursenum: PropTypes.string.isRequired,
  timeframe: PropTypes.string.isRequired,
}

export default DownloadLinksContainer
